module.exports = __webpack_public_path__ + "img/de-praktijk-2.3e80050a.jpg";